import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import ModalChangePhoneNumber from 'screens/ModalChangePhoneNumber';
import ModalChangePIN from 'screens/ModalChangePIN';
import ModalChangeEmailAddress from 'screens/ModalChangeEmailAddress';
import ModalResetPassword from 'screens/ModalResetPassword';
import { Content, Row, Item } from './styles';
import colors from 'constants/colors';
import ModalConfirmationRequired from 'screens/ModalConfirmationRequired';


const Profile = ({ profile }) => {

    return (
      <Card>
        <CardHeader>
          <div className='type'>PROFILE</div>
        </CardHeader>
        <Content>
          <Row>
            <Item>
              <div className='title'>NAME</div>
              <div className='description'>
                {profile.fullName || "N/A"}
              </div>
            </Item>
            <Item>
              <div className='title'>ROLE</div>
              <div className='description'>{profile.roleName || "N/A"}</div>
            </Item>
          </Row>
          <Row>
            <Item>
              <div className='title'>PHONE</div>
              <div className='description'>
                <span>{profile.phoneNumber || "N/A"}</span>
                <ModalChangePhoneNumber
                  userId={profile.userId}
                  buttonStyle={`
                    background: transparent;
                    height: 21px;
                    margin-left: 16px;
                    fontSize: 14px;
                    font-weight: 600;
                    color: ${colors.lightBlue};
                    text-decoration: underline;
                  `}
                />
              </div>
            </Item>
            <Item>
              <div className='title'>PIN</div>
              <div className='description'>
                <span>{profile.hasPIN? "******": "N/A"}</span>
                <ModalChangePIN
                  staffId={profile.staffId}
                  buttonStyle={`
                    background: transparent;
                    height: 21px;
                    margin-left: 16px;
                    fontSize: 14px;
                    font-weight: 600;
                    color: ${colors.lightBlue};
                    text-decoration: underline;
                  `}
                />
              </div>
            </Item>
          </Row>
          <Row>
            <Item>
              <div className='title'>EMAIL</div>
              <div className='description'>
                <span>{profile.email || "N/A"}</span>
                <ModalConfirmationRequired
                  userId={profile.userId}
                  buttonStyle={`
                    background: transparent;
                    height: 21px;
                    margin-left: 16px;
                    fontSize: 14px;
                    font-weight: 600;
                    color: ${colors.lightBlue};
                    text-decoration: underline;
                  `}
                />
                {/* <ModalChangeEmailAddress
                  userId={profile.userId}
                  buttonStyle={`
                    background: transparent;
                    height: 21px;
                    margin-left: 16px;
                    fontSize: 14px;
                    font-weight: 600;
                    color: ${colors.lightBlue};
                    text-decoration: underline;
                  `}
                /> */}
              </div>
            </Item>
            <Item>
              <div className='title'>PASSWORD</div>
              <div className='description'>
                <span>{profile.hasPassword? "********": "N/A"}</span>
                <ModalResetPassword
                  userId={profile.userId}
                  buttonLabel={''}
                  buttonStyle={`
                    background: transparent;
                    height: 21px;
                    margin-left: 16px;
                    fontSize: 14px;
                    font-weight: 600;
                    color: ${colors.lightBlue};
                    text-decoration: underline;
                  `}
                />
              </div>
            </Item>
          </Row>
        </Content>
      </Card>
  )
}

export default Profile;
